import { render, staticRenderFns } from "./SliderPagination.vue?vue&type=template&id=10bc0182&"
import script from "./SliderPagination.vue?vue&type=script&lang=js&"
export * from "./SliderPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports